import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class NumberingFormatDoesNotRespectAsteriskRuleError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.numberings.validation.format.numbering-format-does-not-respect-asterisk-rule');
    }
}
